import React, { useState } from "react";
import "./AlertPercentage.css";
import { TiDelete } from "react-icons/ti";

const AlertPercentage = () => {
  const [AlertPercentage, setAlertPercentage] = useState(true);

  const CloseAlert = () => {
    setAlertPercentage(false);
  };

  return (
    <>
      {AlertPercentage === true ? (
        <div className="boxalertpercentage">
          <p className="textalertpercentage">
            <strong>A PARTIR DE LA VENTA DE OCTUBRE</strong>
            <br />
            <br />
            Estimado comercializador,
            <br />
            <br />
            Le informamos que, debido a los recientes aumentos en los créditos,
            las escalas de comisiones han sido ajustadas. Estas comisiones están
            indexadas al Salario Mínimo, Vital y Móvil, tal como lo establece el
            anexo correspondiente.
            <br />
            <br />
            Nuevas escalas:
            <br />
            <br />
            - Hasta $9.000.000: 7%
            <br />
            - De $9.000.001 a $12.000.000: 9%
            <br />
            - Más de $12.000.001: 11%
            <br />
            <br />
            <br />
            Agradecemos su comprensión y colaboración.
            <br />
            <br />
            Atentamente,
            <br />
            Amebo
          </p>
          <TiDelete className="iconalertpercentage" onClick={CloseAlert} />
        </div>
      ) : null}
    </>
  );
};

export default AlertPercentage;
